<template>
	<v-container>
		<form class="filterContainer">
			<progress-bar :isLoading="someFilterIsLoading"/>
			<v-alert type="error" v-show="shwoMandatorAlert">
				{{ txt.mandatorAlert }}
			</v-alert>
			<v-alert type="error" v-show="shwoIncorrectDateAlert">
				{{ txt.dateAlert }}
			</v-alert>
			<v-alert type="error" v-show="shwoShoppingCartRuleAlert">
				{{ txt.shoppingCartRuleAlert }}
			</v-alert>
			<v-alert type="error" v-show="showMissingDataAlert">
				{{ txt.missingDataAlert }}
				<strong>{{missingDataSince}}</strong>
				</br>{{txt.missingDataAlertPt2}}
			</v-alert>
			<!-- Mandator -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-show="mandatorVisible"
						v-model="formState.selectedMandators"
						:items="formItems.mandator"
						:error-count="mandatorErrorCount"
						:error-messages="mandatorErrorMessage"
						:search-input.sync="searchMandators"
						@change="searchMandators = null"
						hide-selected
						label="Mandator"
						multiple
						persistent-hint
						chips
						return-object
					></v-autocomplete>
				</v-col>
			</v-row>
			<!-- Region -->
			<v-row>
				<v-col cols="12" md="12">
					<v-autocomplete
						v-show="regionVisible"
						v-model="formState.selectedRegions"
						:items="formItems.region"
						hide-selected
						label="Region"
						item-text="region_name"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					></v-autocomplete>
				</v-col>
			</v-row>
			<!-- Sales Channel -->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="salesChannelVisible"
						v-model="formState.selectedSalesChannels"
						:items="formItems.salesChannels"
						:search-input.sync="searchSalesChannels"
						@change="searchSalesChannels = null"
						hide-selected
						label="Sales Channel"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
					</v-autocomplete>
				</v-col>
				<!-- Service Provider -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="serviceProviderVisible"
						v-model="formState.selectedServiceproviders"
						:items="formItems.serviceproviders"
						:search-input.sync="searchServiceproviders"
						@change="searchServiceproviders = null"
						hide-selected
						label="Serviceprovider"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
					</v-autocomplete>
				</v-col>
			</v-row>
			<!-- Product group-->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="productSkuVisible"
						v-model="formState.selectedProducts"
						:items="formItems.products"
						:search-input.sync="searchProducts"
						:filter="filterRegex"
						@keypress="keyPressProductSku"
						@change="searchProducts = null"
						hide-selected
						label="Product SKU"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
						<template slot="item" slot-scope="{ item }">
							<v-list-item-content style="display:block">
								{{item.text ? item.text : item }}
							</v-list-item-content>
						</template>
					</v-autocomplete>
				</v-col>
				<!-- Product SKU -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="productGroupVisible"
						v-model="formState.selectedSkuGroups"
						:items="formItems.skuGropups"
						:search-input.sync="searchSkuGroups"
						@change="searchSkuGroups = null"
						hide-selected
						label="Product group"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
						<template v-slot:prepend-item>
							<v-list-item ripple @click="toggleSelectAllSkuGroups">
								<v-list-item-action>
									<v-icon>{{ allSkuGroupsSelected ? 'mdi-close-box' : 'mdi-checkbox-blank-outline' }}</v-icon>
								</v-list-item-action>
								<v-list-item-content>
									<v-list-item-title style="text-align: left">Select All</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
							<v-divider class="mt-2"></v-divider>
						</template>
					</v-autocomplete>
				</v-col>
			</v-row>

			<!-- Date ranges (Validity and order)-->
			<v-row>
				<v-col cols="1" lg="2" v-show="showSwitch">
					<v-switch
						v-model="switchOrderValidityDate"
						:label="`Filter by: ${switchOrderValidityDate == true ? 'Validity start date' : 'Order date'}`"
						:disabled="someFilterIsLoading"
					/>
				</v-col>
				<!-- Order Date Pickers -->
				<v-col cols="12" md="5" v-show="dateFromVisible && switchOrderValidityDate == false">
					<v-menu
						ref="menuFrom"
						v-model="menuFrom"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateFromTemp"
								:rules="[rules.dateFormat]"
								label="Date from"
								v-bind="attrs"
								v-on="on"
								:disabled="someFilterIsLoading"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateFromFinal"
							no-title
							@input="menuFrom = false"
							:first-day-of-week="1"
							:allowed-dates="allowedDates"
						></v-date-picker>
					</v-menu>
				</v-col>

				<v-col cols="12" md="5" v-show="dateTillVisible && switchOrderValidityDate == false">
					<v-menu
						ref="menuTill"
						v-model="menuTill"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="formState.dateTillTemp"
								:rules="[rules.dateFormatTill]"
								label="Date till"
								v-on="on"
								:disabled="someFilterIsLoading"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateTillFinal"
							no-title
							@input="menuTill = false"
							:first-day-of-week="1"
							:allowed-dates="allowedDates"
						></v-date-picker>
					</v-menu>
				</v-col>
				<!-- Validity Date Pickers -->
				<v-col cols="12" md="5" v-show="switchOrderValidityDate == true">
					<v-menu
						ref="menuFromValidity"
						v-model="menuFromValidity"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateFromValidityTemp"
								label="Validity Date From"
								:rules="[rules.dateFormat]"
								v-bind="attrs"
								v-on="on"
								:disabled="someFilterIsLoading"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateFromValidity"
							no-title
							@input="menuFromValidity = false"
							:first-day-of-week="1"
						></v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="12" md="5" v-show="switchOrderValidityDate == true">
					<v-menu
						ref="menuTillValidity"
						v-model="menuTillValidity"
						:close-on-content-click="false"
						transition="scale-transition"
						offset-y
						max-width="290px"
						min-width="290px"
					>
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								v-model="formState.dateTillValidityTemp"
								label="Validity Date Till"
								:rules="[rules.dateFormat]"
								v-bind="attrs"
								v-on="on"
								:disabled="someFilterIsLoading"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="formState.dateTillValidity"
							no-title
							@input="menuTillValidity = false"
							:first-day-of-week="1"
						></v-date-picker>
					</v-menu>
				</v-col>
			</v-row>

			<!-- Group after day, month, year-->
			<v-row>
				<v-col cols="12" md="6">
					<v-select
						v-show="groupingVisible"
						v-model="formState.selectedGrouping"
						label="Grouping"
						:items="formItems.dateSortAfter"
						:disabled="someFilterIsLoading"
					></v-select>
				</v-col>
				<!-- Payment Method  -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="paymentTypeVisible"
						v-model="formState.selectedPaymentMethods"
						:items="formItems.paymentMethods"
						:search-input.sync="searchPaymentMethods"
						@change="searchPaymentMethods = null"
						hide-selected
						label="Payment Type"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
					</v-autocomplete>
				</v-col>
			</v-row>
			<!-- Booking / Refund -->
			<v-row>
				<v-col cols="12" md="6">
					<v-combobox
						v-show="bookingRefundVisible"
						v-model="formState.selectedBookings"
						:items="formItems.booking"
						label="Booking / refund"
						multiple
						chips
						:disabled="someFilterIsLoading"
					></v-combobox>
				</v-col>
				<!-- Reseller -->
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="resellerVisible"
						v-model="formState.selectedResellers"
						:items="formItems.resellers"
						:search-input.sync="searchResellers"
						@change="searchResellers = null"
						hide-selected
						label="Reseller"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
					</v-autocomplete>
				</v-col>
			</v-row>
			<!-- Coupon code rule -->
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="shoppingCartRuleVisible"
						v-model="formState.selectedShoppingCartRule"
						:items="formItems.shoppingCartRule"
						:search-input.sync="searchShoppingCartRule"
						@change="searchShoppingCartRule = null"
						hide-selected
						label="Shopping Cart Price Rule"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					>
					</v-autocomplete>
				</v-col>
				<!-- coupon code for individual oders -->
				<v-col cols="12" :md="couponCodeCols">
					<v-text-field
						v-model="formState.requestedCouponCode"
						label="Coupon Code of Shopping Cart Price Rule"
						persistent-hint
						return-object
						:disabled="someFilterIsLoading"
					>
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-model="formState.selectedItemStatus"
						:items="formItems.itemStatus"
						hide-selected
						label="Item Status"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					></v-autocomplete>
				</v-col>
				<v-col cols="12" md="6">
					<v-autocomplete
						v-show="cashdeskFilterVisible"
						v-model="formState.selectedCashdesk"
						:items="formItems.cashdesk"
						hide-selected
						label="Cashdesk Name"
						multiple
						persistent-hint
						chips
						return-object
						:disabled="someFilterIsLoading"
					></v-autocomplete>
				</v-col>
			</v-row>
			<v-btn
				:loading="loadingData"
				:disabled="loadingData || someFilterIsLoading"
				color="primary"
				class="searchButton"
				@click="submitFilters"
				>{{ txt.button.showData }}
			</v-btn>

			<v-layout align-center justify-center class="dataLoading">
				<v-progress-circular
					indeterminate
					color="primary"
					v-show="loadingData"
				></v-progress-circular>
			</v-layout>
		</form>
	</v-container>
</template>

<script>
import axios from 'axios'
import ProgressBar from '../vueBasics/Progressbar.vue'

export default {
	name: 'ReportingsystemFilter',
	props: ['approvedMandators', 'appNameShort'],
	components: {
		ProgressBar,
	},
	data() {
		return {
			formState: {
				selectedMandators: [],
				selectedRegions: [],
				selectedSalesChannels: [],
				selectedServiceproviders: [],
				selectedProducts: [],
				selectedSkuGroups: [],
				dateFromTemp: new Date().toISOString().substr(0, 10),
				dateFromFinal: new Date().toISOString().substr(0, 10),
				dateTillTemp: new Date().toISOString().substr(0, 10),
				dateTillFinal: new Date().toISOString().substr(0, 10),
				dateFromValidity: new Date().toISOString().substr(0, 10),
				dateTillValidity: new Date().toISOString().substr(0, 10),
				dateFromValidityTemp: new Date().toISOString().substr(0, 10),
				dateTillValidityTemp: new Date().toISOString().substr(0, 10),
				selectedGrouping: 'Day',
				selectedBookings: [],
				selectedResellers: [],
				selectedPaymentMethods: [],
				selectedShoppingCartRule: [],
				requestedCouponCode: [],
				selectedCashdesk: [],
				selectedItemStatus: [],
			},
			formItems: {
				mandator: ['Mandators could not be loaded'],
				region: ['Regions could not be loaded'],
				salesChannels: ['Sales channels could not be loaded'],
				serviceproviders: [
					'Serviceproviders could not be loaded due unknown mandator',
				],
				products: [],
				skuGroups: [],
				dateSortAfter: ['Day', 'Month', 'Year', 'Ungrouped'],
				paymentMethods: [],
				booking: [
					{ text: 'Bookings', value: 0 },
					{ text: 'Refunds', value: 1 },
				],
				resellers: [],
				heckForComma: [],
				shoppingCartRule: [],
				cashdesk: [],
				itemStatus: [],
			},
			txt: {
				searchBtn: 'Search',
				button: {
					showData: 'Show Data',
				},
				mandatorAlert: 'Please select at least one mandator.',
				dateAlert: 'Incorrect date. The correct format is YYYY-MM-DD',
				shoppingCartRuleAlert: 'Shopping cart price rule only applies in "Ungrouped" grouping',
				missingDataAlert: 'We experience an error. No new data available since ',
				missingDataAlertPt2: ' We try to make it work as soon as possible.',
			},
			// var for datepickers
			menuFrom: false,
			menuTill: false,
			menuFromValidity: false,
			menuTillValidity: false,
			modal: false,
			switchOrderValidityDate: false,
			// Autocomplete fields search
			searchMandators: null,
			searchSalesChannels: null,
			searchServiceproviders: null,
			searchProducts: null,
			searchSkuGroups: null,
			searchPaymentMethods: null,
			searchResellers: null,
			searchShoppingCartRule: null,

			loadingData: null,
			loadingDetailData: null,
			showFilter: true,
			shwoMandatorAlert: false,
			shwoShoppingCartRuleAlert: false,
			showMissingDataAlert: false,
			missingDataSince: '',

			noResult: false,
			mandatorVisible: true,
			regionVisible: true,
			salesChannelVisible: true,
			serviceProviderVisible: true,
			productSkuVisible: true,
			productGroupVisible: true,
			dateFromVisible: true,
			dateTillVisible: true,
			groupingVisible: true,
			paymentTypeVisible: true,
			bookingRefundVisible: true,
			resellerVisible: true,
			shoppingCartRuleVisible: true,
			cashdeskFilterVisible: true,
			couponCodeCols: 6,
			showSwitch: true,

			appName: this.appNameShort,
			mandatorSelectionDisabled: false,
			rules: {
				dateFormat: () => this.dateFromCorrect || 'Date is not valid. YYYY-MM-DD',
				dateFormatTill: () => this.dateTillCorrect || 'Date is not valid. YYYY-MM-DD',
				// eslint-disable-next-line max-len
				groupingIssueAlert: () => this.groupingIssueMessage || 'Shopping cart price rule delivers a result only in "Ungrouped" grouping',
			},
			dateFromCorrect: false,
			dateTillCorrect: false,
			shwoIncorrectDateAlert: false,
			mandatorErrorCount: 0,
			mandatorErrorMessage: '',
			groupingIssueMessage: false,
			loadFilter: {
				serviceprovider: false,
				saleschannels: false,
				skuPartOne: false,
				productSku: false,
				paymentMethod: false,
				reseller: false,
				shoppingCartRule: false,
				cashdesk: false,
				itemStatus: false,
			},
			resellerExportEnabled: false,
		}
	},
	watch: {
		'formState.dateFromTemp': {
			handler() {
				this.parseDate(this.formState.dateFromTemp)
			},
		},
		'formState.dateFromFinal': {
			handler() {
				this.setDateAsFinal(this.formState.dateFromFinal)
			},
		},
		'formState.dateTillTemp': {
			handler() {
				this.parseTillDate(this.formState.dateTillTemp)
			},
		},
		'formState.dateTillFinal': {
			handler() {
				this.setTillDateLikePicker(this.formState.dateTillFinal)
			},
		},
		'formState.dateFromValidity': {
			handler() {
				this.formState.dateFromValidityTemp = this.formState.dateFromValidity
			},
		},
		'formState.dateTillValidity': {
			handler() {
				this.formState.dateTillValidityTemp = this.formState.dateTillValidity
			},
		},

		'formItems.mandator': {
			handler() {
				this.mandatorAutofill()
				this.notEmptyMandator()
				// if (this.formState.selectedMandators[0]) this.getRegions(this.formState.selectedMandators[0].value)
			},
		},
		'formState.selectedMandators': {
			handler() {
				// only allow one mandator before filling the filters and empty selected regions
				if (this.formState.selectedMandators.length > 1) {
					this.popFirstMandator(this.formState.selectedMandators)
					this.formState.selectedRegions = []
					return
				}
				this.resetSelectedFilters()
				this.notEmptyMandator()
				if (this.formState.selectedMandators[0]) {
					this.getMissingDataDate(this.formState.selectedMandators[0].value)
				}
				this.getRegions(this.formState.selectedMandators[0].value)
				this.getServiceprovider(this.formState.selectedMandators)
				this.getSaleschannels(this.formState.selectedMandators)
				this.getSkuPartOne(this.formState.selectedMandators)
				this.getProductSku(this.formState.selectedMandators)
				this.getPaymentMethod(this.formState.selectedMandators)
				this.getReseller(this.formState.selectedMandators)
				this.getShoppingCartRule(this.formState.selectedMandators)
				this.getCashdesks(this.formState.selectedMandators)
				this.getItemStatus(this.formState.selectedMandators)
				this.setResellerExportEnabled(this.formState.selectedMandators[0].value)
			},
		},
		/* 'formState.selectedRegions': { // here add all handlers for the region filtering
			handler() {
				if (this.formItems.region.length === 0) return
				this.getServiceprovider(this.formState.selectedMandators)
				this.getSaleschannels(this.formState.selectedMandators)
				this.getSkuPartOne(this.formState.selectedMandators)
				this.getProductSku(this.formState.selectedMandators)
			},
		}, */
		'formState.selectedProducts': {
			handler() {
				this.productOrSku()
			},
		},
		'formState.selectedSkuGroups': {
			handler() {
				this.productOrSku()
			},
		},
		'formState.selectedShoppingCartRule': {
			handler() {
				this.setGroupingIssueMessage()
			},
		},
		'formState.requestedCouponCode': {
			handler() {
				this.hideShowFieldsIfCouponCode()
			},
		},
	},
	computed: {
		allSkuGroupsSelected() {
			return this.formState.selectedSkuGroups.length === this.formItems.skuGropups.length
		},
		someFilterIsLoading() {
			// start to spin if a mandator is seleted and if any of the filters is still loading
			const showLoader = !!((
				this.formState.selectedMandators.length > 0
				&& (
					this.loadFilter.serviceprovider
					|| this.loadFilter.saleschannels
					|| this.loadFilter.skuPartOne
					|| this.loadFilter.productSku
					|| this.loadFilter.paymentMethod
					|| this.loadFilter.reseller
					|| this.loadFilter.shoppingCartRule
					|| this.loadFilter.cashdesk
					|| this.loadFilter.itemStatus
				)
			))
			return showLoader
		},
	},
	methods: {
		allowedDates(val) {
			const d1 = new Date(val)
			const d2 = new Date()
			return d1 < d2
		},
		makeRegexString(inputText) {
			// escape every regex metacharacter (real SKUs contain "(", ")", "+", etc.) so they
			// match literally instead of breaking regex construction, then turn the user's
			// literal "*" wildcard (now escaped as "\*") into "one or more of any character" -
			// real SKUs contain spaces/umlauts/punctuation a restricted char class can't span
			const escaped = inputText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
			return escaped.replace(/\\\*/g, '.+')
		},
		filterRegex(item, inputText) {
			const regexString = this.makeRegexString(inputText)
			try {
				const regex = new RegExp(regexString, 'i')
				return regex.test(item.value)
			} catch (err) {
				return false
			}
		},
		keyPressProductSku(event) {
			if (event.key == 'Enter') {
				try {
					// eslint-disable-next-line no-underscore-dangle
					const textFieldInput = event.target._value
					const regexString = new RegExp(this.makeRegexString(textFieldInput), 'i')
					this.formState.selectedProducts = this.formItems.products.filter((el) => regexString.test(el.value))
				} catch (err) {
					this.formState.selectedProducts = []
				}
			}
		},
		toggleSelectAllSkuGroups() {
			if (this.allSkuGroupsSelected) {
				this.formState.selectedSkuGroups = []
			} else {
				this.formState.selectedSkuGroups = this.formItems.skuGropups.slice()
			}
		},
		async getMandators(appNameShort) {
			try {
				// eslint-disable-next-line no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/mandator?appNameShort=${appNameShort}`)
				this.formItems.mandator = r.data
			} catch (e) {
				console.log(e)
			}
		},
		async getRegions(installationid) {
			try {
				if (installationid === 9999 || installationid === '') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/region?installation_id=${installationid}`)
				this.formItems.region = r.data
				// if there is only one region allowed for user, do not show the drop down for regions
				if (this.formItems.region.length === 1) {
					this.regionVisible = false
					/* if there is only one region named null - regions are still not provided for that mandator
					and no region filtering should be done */
					if (this.formItems.region[0].region_name == null) {
						this.formItems.region = []
						this.formState.selectedRegions = []
					} else this.formState.selectedRegions = r.data
				} else {
					this.regionVisible = true
				}
			} catch (e) {
				// TODO: error handling
				console.log(e)
			}
		},
		mandatorAutofill() {
			if (this.formItems.mandator.length === 1) {
				this.formState.selectedMandators = this.formItems.mandator
				this.mandatorVisible = false
			}
		},
		getMandatorValues(selectedMandators) {
			const mandators = []
			if (selectedMandators && selectedMandators.length > 0) {
				selectedMandators.forEach((mandator) => {
					mandators.push(mandator.value)
				})
			} else {
				mandators.push('9999')
			}
			return mandators
		},
		async getServiceprovider(selectedMandators) {
			try {
				this.loadFilter.serviceprovider = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				const r = await axios.get(
					// eslint-disable-next-line max-len, no-undef
					`${config.baseAPIurl}/revenue-report/service-provider?installationid=${mandators.join(',')}`,
					{
						params: {
							regionsid: this.formState.selectedRegions,
						},
					},
				)
				this.formItems.serviceproviders = r.data
				if (r.data.length <= 0) this.formItems.serviceproviders.push('No mandator has been selected.')
				this.loadFilter.serviceprovider = false
			} catch (e) {
				// TODO error handling
				console.log(e)
				this.loadFilter.serviceprovider = false
			}
		},
		async getSaleschannels(selectedMandators) {
			try {
				this.loadFilter.saleschannels = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/sales-channel?installationid=${mandators.join(',')}`, {
					params: {
						regionsid: this.formState.selectedRegions,
					},
				})
				this.formItems.salesChannels = r.data
				if (r.data.length <= 0) this.formItems.salesChannels.push('No mandator has been selected.')
				this.loadFilter.saleschannels = false
			} catch (e) {
				this.loadFilter.saleschannels = false
				console.log(e)
			}
		},
		async getSkuPartOne(selectedMandators) {
			try {
				this.loadFilter.skuPartOne = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/sku-part-one?installationid=${mandators.join(',')}`, {
					params: {
						regionsid: this.formState.selectedRegions,
					},
				})
				this.formItems.skuGropups = r.data
				if (r.data.length <= 0) this.formItems.skuGropups.push('No mandator has been selected.')
				this.loadFilter.skuPartOne = false
			} catch (e) {
				console.log(e)
				this.loadFilter.skuPartOne = false
			}
		},
		async getProductSku(selectedMandators) {
			try {
				this.loadFilter.productSku = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/sku?installationid=${mandators.join(',')}`, {
					params: {
						regionsid: this.formState.selectedRegions,
					},
				})
				this.formItems.products = r.data
				if (r.data.length <= 0) this.formItems.products.push('No mandator has been selected.')
				this.loadFilter.productSku = false
			} catch (e) {
				console.log(e)
				this.loadFilter.productSku = false
			}
		},
		async getPaymentMethod(selectedMandators) {
			try {
				this.loadFilter.paymentMethod = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/payment-method?installationid=${mandators.join(',')}`)
				this.formItems.paymentMethods = r.data
				if (r.data.length <= 0) this.formItems.paymentMethods.push('No mandator has been selected.')
				this.loadFilter.paymentMethod = false
			} catch (e) {
				console.log(e)
				this.loadFilter.paymentMethod = false
			}
		},
		async getReseller(selectedMandators) {
			try {
				this.loadFilter.reseller = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/reseller?installationid=${mandators.join(',')}`)
				this.formItems.resellers = r.data
				if (r.data.length <= 0) this.formItems.resellers.push('No mandator has been selected.')
				this.loadFilter.reseller = false
			} catch (e) {
				console.log(e)
				this.loadFilter.reseller = false
			}
		},
		async getMissingDataDate(installationid) {
			try {
				if (installationid === '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/missing-data-since?installation_id=${installationid}`)
				if (r.data.rr_missing_data_flag) {
					this.showMissingDataAlert = true
					this.missingDataSince = r.data.rr_missing_data_since
				} else {
					this.showMissingDataAlert = false
				}
			} catch (e) {
				console.log(e)
			}
		},
		async getCashdesks(selectedMandators) {
			try {
				this.cashdeskFilterVisible = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				this.loadFilter.cashdesk = true
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/cashdesk-name?installationid=${mandators.join(',')}`)
				this.formItems.cashdesk = r.data
				if (r.data.length <= 0) this.cashdeskFilterVisible = false
			} catch (e) {
				console.log(e)
			} finally {
				this.loadFilter.cashdesk = false
			}
		},
		async getItemStatus(selectedMandators) {
			try {
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') === '9999') return
				this.loadFilter.itemStatus = true
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/item-status?installationid=${mandators.join(',')}`)
				this.formItems.itemStatus = r.data
			} catch (e) {
				console.log(e)
			} finally {
				this.loadFilter.itemStatus = false
			}
		},
		async submitFilters() {
			let filterData = {}
			let showVariables = {}
			if (this.formState.requestedCouponCode.length === 0) {
				filterData = {
					mandators: this.formState.selectedMandators,
					salesChannels: this.formState.selectedSalesChannels,
					serviceProviders: this.formState.selectedServiceproviders,
					products: this.formState.selectedProducts,
					skuGroups: this.formState.selectedSkuGroups,
					dateFrom: this.formState.dateFromFinal,
					dateTill: this.formState.dateTillFinal,
					dateFromValidity: this.formState.dateFromValidity,
					dateTillValidity: this.formState.dateTillValidity,
					switchOrderValidityDate: this.switchOrderValidityDate,
					grouping: this.formState.selectedGrouping,
					booking: this.formState.selectedBookings,
					resellers: this.formState.selectedResellers,
					paymentMethods: this.formState.selectedPaymentMethods,
					shoppingCartRules: this.formState.selectedShoppingCartRule,
					couponCode: '',
					allowedRegions: this.formState.selectedRegions,
					cashdesk: this.formState.selectedCashdesk,
					itemStatus: this.formState.selectedItemStatus,
				}
				showVariables = {
					loadingData: true,
					showDataTable: true,
					showSelectedFilters: true,
					showSums: true,
					showBackButton: true,
					showFilters: false,
				}
			} else {
				filterData = {
					mandators: this.formState.selectedMandators,
					salesChannels: [],
					serviceProviders: [],
					products: [],
					skuGroups: [],
					dateFrom: '2010-01-01',
					dateTill: '2030-12-31',
					grouping: 'Ungrouped',
					booking: [],
					resellers: [],
					paymentMethods: [],
					shoppingCartRules: [],
					couponCode: this.formState.requestedCouponCode,
					allowedRegions: this.formState.selectedRegions,
					cashdesk: [],
				}
				showVariables = {
					loadingData: true,
					showDataTable: true,
					showSelectedFilters: false,
					showSums: false,
					showBackButton: true,
					showFilters: false,
				}
			}

			const selectedFiltersAndBooleans = {
				filterData,
				showVariables,
				resellerExportEnabled: this.resellerExportEnabled,
			}
			this.shwoIncorrectDateAlert = !(this.dateFromCorrect || this.dateTillCorrect)
			this.shwoMandatorAlert = this.formState.selectedMandators.length <= 0
			this.shwoShoppingCartRuleAlert = false
			if (!this.shwoIncorrectDateAlert && !this.shwoMandatorAlert && !this.shwoShoppingCartRuleAlert) {
				this.showFilter = false
				this.shwoMandatorAlert = false
				this.shwoIncorrectDateAlert = false
				this.shwoShoppingCartRuleAlert = false
				// eslint-disable-next-line no-undef
				const r = await axios.post(`${config.baseAPIurl}/revenue-report/filter`, {
					filterOptions: filterData,
				})
				selectedFiltersAndBooleans.filterId = r.data[0].filterId
				this.$emit('submit', selectedFiltersAndBooleans)
			}
		},
		setFromTimeOnLoad() {
			// sets from time to yesterday on page load, since the newest order is always from yesterday
			const dateYesterday = new Date(Date.now() - 864e5)
			const yearYesterday = dateYesterday.getFullYear()
			let monthYesterday = dateYesterday.getMonth() + 1
			let dayYesterday = dateYesterday.getDate()
			if (monthYesterday < 10) monthYesterday = `0${monthYesterday.toString()}`
			else monthYesterday = monthYesterday.toString()

			if (dayYesterday < 10) dayYesterday = `0${dayYesterday.toString()}`
			else dayYesterday = dayYesterday.toString()
			const yesterdayDate = `${yearYesterday.toString()}-${monthYesterday}-${dayYesterday}`
			this.formState.dateTillFinal = yesterdayDate
			this.formState.dateFromFinal = yesterdayDate
			return yesterdayDate
		},
		parseDate(date) {
			const dateSplitted = date.split('-')
			if (
				dateSplitted.length === 3
				&& dateSplitted[0].length === 4
				&& dateSplitted[1].length === 2
				&& dateSplitted[2].length === 2
				&& date.length === 10
			) {
				const dateParsable = date.split('-').join('/')
				const dateISOString = new Date(dateParsable)
				// eslint-disable-next-line eqeqeq
				if (dateISOString != 'Invalid Date') {
					this.formState.dateFromFinal = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.formState.dateFromTemp = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.dateFromCorrect = true
					this.menuFrom = false
					return true
				}
			}
			this.dateFromCorrect = false
			return false
		},
		parseTillDate(date) {
			const dateSplitted = date.split('-')
			if (
				dateSplitted.length == 3
				&& dateSplitted[0].length == 4
				&& dateSplitted[1].length == 2
				&& dateSplitted[2].length == 2
				&& date.length == 10
			) {
				const dateParsable = date.split('-').join('/')
				const dateISOString = new Date(dateParsable)
				if (dateISOString != 'Invalid Date') {
					this.formState.dateTillFinal = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.formState.dateTillTemp = `${dateSplitted[0]}-${dateSplitted[1]}-${dateSplitted[2]}`
					this.dateTillCorrect = true
					this.menuTill = false
					return true
				}
			}
			this.dateTillCorrect = false
			return false
		},
		setDateAsFinal(dateInDatePicker) {
			this.formState.dateFromTemp = dateInDatePicker
		},
		setTillDateLikePicker(dateInDatePicker) {
			this.formState.dateTillTemp = dateInDatePicker
		},
		notEmptyMandator() {
			if (this.formState.selectedMandators.length === 0) {
				this.mandatorErrorCount = 1
				this.mandatorErrorMessage = 'Required field'
			} else {
				this.mandatorErrorCount = 0
				this.mandatorErrorMessage = ''
			}
		},
		productOrSku() {
			if (
				this.formState.selectedProducts.length == 0
				&& this.formState.selectedSkuGroups.length == 0
			) {
				this.productSkuVisible = true
				this.productGroupVisible = true
			}
			if (
				this.formState.selectedProducts.length !== 0
				&& this.formState.selectedSkuGroups.length == 0
			) {
				this.productSkuVisible = true
				this.productGroupVisible = false
			}
			if (
				this.formState.selectedProducts.length == 0
				&& this.formState.selectedSkuGroups.length !== 0
			) {
				this.productSkuVisible = false
				this.productGroupVisible = true
			}
		},
		popFirstMandator(mandators) {
			// remove the first item of the mandator array -> only one at the time
			if (mandators.length > 1) {
				this.formState.selectedMandators.shift()
			}
		},
		async getShoppingCartRule(selectedMandators) {
			try {
				this.loadFilter.shoppingCartRule = true
				const mandators = this.getMandatorValues(selectedMandators)
				if (mandators.join(',') == '9999') return
				// eslint-disable-next-line max-len, no-undef
				const r = await axios.get(`${config.baseAPIurl}/revenue-report/shopping-cart-rule?installationid=${mandators.join(',')}`)
				this.formItems.shoppingCartRule = r.data
				if (r.data.length <= 0) this.formItems.shoppingCartRule.push('No mandator has been selected.')
				this.loadFilter.shoppingCartRule = false
			} catch (e) {
				console.log(e)
				this.loadFilter.shoppingCartRule = false
			}
		},
		setGroupingIssueMessage() {
			if (
				this.formState.selectedShoppingCartRule.length !== 0
				&& this.formState.selectedGrouping == 'Ungrouped') {
				this.groupingIssueMessage = true
				return true
			}

			if (this.formState.selectedShoppingCartRule.length == 0) {
				this.groupingIssueMessage = true
				return true
			}
			this.groupingIssueMessage = false
			return false
		},
		hideShowFieldsIfCouponCode() {
			if (this.formState.requestedCouponCode.length == 0) {
				setTimeout(() => {
					this.salesChannelVisible = true
					this.serviceProviderVisible = true
					this.productSkuVisible = true
					this.productGroupVisible = true
					this.dateFromVisible = true
					this.dateTillVisible = true
					this.groupingVisible = true
					this.paymentTypeVisible = true
					this.bookingRefundVisible = true
					this.resellerVisible = true
					this.shoppingCartRuleVisible = true
					this.cashdeskFilterVisible = true
					this.showSwitch = true
					this.couponCodeCols = 6
				}, 150)
			} else {
				setTimeout(() => {
					this.salesChannelVisible = false
					this.serviceProviderVisible = false
					this.productSkuVisible = false
					this.productGroupVisible = false
					this.dateFromVisible = false
					this.dateTillVisible = false
					this.groupingVisible = false
					this.paymentTypeVisible = false
					this.bookingRefundVisible = false
					this.resellerVisible = false
					this.shoppingCartRuleVisible = false
					this.cashdeskFilterVisible = false
					this.showSwitch = false
					this.couponCodeCols = 12
				}, 150)
			}
		},
		resetSelectedFilters() {
			this.formState.selectedRegions = []
			this.formState.selectedSalesChannels = []
			this.formState.selectedServiceproviders = []
			this.formState.selectedProducts = []
			this.formState.selectedSkuGroups = []
			this.formState.selectedGrouping = 'Day'
			this.formState.selectedBookings = []
			this.formState.selectedResellers = []
			this.formState.selectedPaymentMethods = []
			this.formState.selectedShoppingCartRule = []
			this.formState.selectedCashdesk = []
			this.formState.selectedItemStatus = []
		},
		async setResellerExportEnabled(mandatorId) {
			// eslint-disable-next-line no-undef
			const response = await axios.get(`${config.baseAPIurl}/revenue-report/reseller-export-enabled?mandatorId=${mandatorId}`)
			this.resellerExportEnabled = response.data.resellerExportEnabled
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.getMandators(this.appName)
			this.getServiceprovider(this.formState.selectedMandators)
			this.getRegions(this.formState.selectedMandators)
			this.getSaleschannels(this.formState.selectedMandators)
			this.getSkuPartOne(this.formState.selectedMandators)
			this.getProductSku(this.formState.selectedMandators)
			this.getPaymentMethod(this.formState.selectedMandators)
			this.getReseller(this.formState.selectedMandators)
			this.parseDate(this.formState.dateFromFinal)
			this.parseTillDate(this.formState.dateTillFinal)
			this.getShoppingCartRule(this.formState.selectedMandators)
			this.getCashdesks(this.formState.selectedMandators)
			this.getItemStatus(this.formState.selectedMandators)
		})
		this.setFromTimeOnLoad()
	},
}
</script>

<style scoped>
form {
	padding: 60px 60px 0px 30px;
}
.searchButton {
	color: #00a0e3;
}
.filterContainer {
	padding: 0px !important;
}
.dataLoading {
	padding-top: 11px;
}

</style>
